import { useRef, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import "../Home/home.css";
import PortalContext from "../PortalContext";
import { sendGetRequest } from "../../Client/index.js";

export default function TrackBox() {
  const { portal } = useContext(PortalContext);
  const orderNumberRef = useRef();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const code = orderNumberRef.current?.value?.trim();
    if (!code) return;

    setLoading(true);
    setResults(null);

    const res = await sendGetRequest(
      `api/v2-label-portal-tracking.php?ref=${code}`
    );

    setLoading(false);

    setResults(res || []);
  };

  return (
    <>
      <Header />

      <section className="page3-slider">
        <div className="container">
          <div className="row d-flex align-items-center mt-3">
            <div className="col-lg-5 col-12 pb-5">
              <h2>Track your parcel</h2>
              <p className="pt-3 text-muted mb-4">
                Enter your order number or tracking number below to see the
                latest tracking.
              </p>

              <form className="align-items-center" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      placeholder="Order or tracking number"
                      name="trackingNumber"
                      id="trackingNumber"
                      required
                      ref={orderNumberRef}
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-sm-12">
                    <button
                      type="submit"
                      disabled={loading}
                      style={{
                        backgroundColor: loading
                          ? "#ccc"
                          : portal.data.settings.colours.primary,
                        opacity: loading ? 0.8 : 1,
                        cursor: loading ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {loading ? (
                        <>
                          <div
                            className="spinner-border spinner-border-sm text-light"
                            role="status"
                          />
                          <span>Loading...</span>
                        </>
                      ) : (
                        "View Tracking"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-7 col-12"></div>
          </div>

          {results !== null && (
            <>
              {results.length === 0 ? (
                <div
                  style={{
                    backgroundColor: "#f8d7da",
                    color: "#842029",
                    fontWeight: "500",
                    textAlign: "center",
                    marginTop: "1rem",
                    padding: "1rem 1.25rem",
                    borderRadius: "8px",
                    border: "1px solid #f5c2c7",
                    width: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  No tracking available.
                </div>
              ) : (
                <div className="table-responsive mt-1 mb-5">
                  <table className="table table-striped mb-0">
                    <thead className="table-light">
                      <tr>
                        <th key={"date"}>Date</th>
                        <th key={"status"}>Status</th>
                        <th key={"location"}>Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((item, index) => (
                        <tr key={index}>
                          {Object.keys(item).map((key) => (
                            <td key={key}>{item[key]}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
}
